// The signed-in screen chassis. Figma `Screen/Template` 29:57:
//   Shell/Sidebar 240×1024 at x=0, then main at x=240 width 1200 containing
//   Shell/Topbar 1200×56 and body-slot 1200×968 at y=56.
//
// NOT used by the six S1 auth frames or /no-access — those are pre-login and
// deliberately carry no chrome. Adding it there is wrong, not an omission.

import type { ReactNode } from "react";
import { ImpersonationBanner } from "./ImpersonationBanner";
import { Sidebar } from "./Sidebar";
import { Topbar } from "./Topbar";
import type { ShellNav } from "./hrefs";
import "../tokens/paper.css";
import "./shell.css";

export type AppShellProps = {
  /** Which audience this chassis is drawing for — `orgNav` or `adminNav`. */
  nav: ShellNav;
  /** Trailing breadcrumb segment — the screen's own name. */
  title?: string;
  /** Page-level actions for the topbar's right side. */
  actions?: ReactNode;
  onSignOut?: () => void;
  children: ReactNode;
};

export function AppShell({
  nav,
  title,
  actions,
  onSignOut,
  children,
}: AppShellProps) {
  return (
    <div className="maisight-shell" data-chassis="paper">
      <Sidebar nav={nav} />
      <div className="maisight-shell-main">
        {/* Above the topbar, not inside it. Renders nothing unless the session
            is an operator viewing a tenant. */}
        <ImpersonationBanner />
        <Topbar
          identity={nav.identity}
          title={title}
          actions={actions}
          onSignOut={onSignOut}
        />
        <main className="maisight-shell-body">{children}</main>
      </div>
    </div>
  );
}
